var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5082_91329",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 104,
    height: 104
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 43",
    cx: 52,
    cy: 52,
    r: 52,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5082_91329)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 145",
    x: -31,
    y: -16,
    width: 165,
    height: 136,
    fill: "#FFFF04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.7633 72.9201C27.3218 61.7071 30.8065 50.7253 34.3462 39.5731C36.6296 41.2923 38.7984 42.8972 40.917 44.566C41.1226 44.7284 41.1446 45.3262 41.041 45.6551C39.5007 50.5549 37.9219 55.4422 36.3589 60.3349C35.9045 61.7584 35.4714 63.1882 34.9841 64.7568C35.5263 64.7868 35.9242 64.8278 36.3212 64.8278C45.822 64.8325 55.3236 64.8333 64.8245 64.8333C65.431 64.8333 66.0391 64.9706 66.3051 64.1038C67.286 60.909 68.3312 57.7348 69.3465 54.5502C69.4077 54.3594 69.4156 54.1512 69.4729 53.8034H47.4918C48.1941 51.6094 48.803 49.5896 49.5225 47.6094C49.6073 47.3759 50.2939 47.2647 50.7019 47.2631C57.2029 47.2419 63.7039 47.2119 70.2042 47.2797C71.3859 47.2923 71.8716 46.9232 72.1902 45.8128C72.9152 43.2892 73.7831 40.8073 74.665 38.0865H20.124L20 37.7505C20.5964 37.2797 21.1825 36.7939 21.7906 36.3396C24.3298 34.4453 26.8565 32.5305 29.4357 30.6914C29.9701 30.3105 30.7116 30.0305 31.3581 30.0289C46.2764 29.9911 61.1953 29.9919 76.1136 30.0226C76.728 30.0242 77.431 30.2505 77.9403 30.5983C79.7646 31.8436 81.5019 33.2166 83.3169 34.4769C84.0317 34.9729 84.1345 35.4603 83.8598 36.2616C82.8853 39.1054 82.0261 41.9903 81.0185 44.8215C80.7965 45.4453 80.2488 46.1141 79.6713 46.4217C76.662 48.0218 73.5955 49.5124 70.2999 51.1654C71.9108 52.3791 73.3382 53.4926 74.8047 54.5518C77.3604 56.3964 77.3502 56.3751 76.3521 59.3688C75.5596 61.7458 74.7945 64.1322 74.0797 66.5329C73.8239 67.3917 73.4253 67.9706 72.5841 68.372C69.8409 69.6811 67.1549 71.1109 64.4094 72.4138C63.6859 72.7576 62.8259 72.9721 62.0287 72.9745C49.7776 73.0092 37.5257 72.9997 25.2738 72.9958C24.8289 72.9958 24.3848 72.9524 23.7633 72.9193V72.9201Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlast);
export default __webpack_public_path__ + "static/media/BLAST.5cfd3ca58686a00c8e538ea794004c5c.svg";
export { ForwardRef as ReactComponent };